/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * Event helper class
 **/
define([
	'underscore',
	'../lib/@waca/dashboard-common/dist/utils/ContentUtil'
], (_, ContentUtilCommon) => {

	class ContentUtil {

		/**
		 * Gets the page context api from the Page Context Service
		 * @param {DashboardAPI} dashboard
		 * @returns {pageContextAPI} page content api.
		 */
		static getPageContext(dashboard) {
			const pageContextService = dashboard.getFeature('PageContextService');
			return pageContextService && pageContextService.getPageContext();
		}

		static _resolvePageContextItems(pageContextItems, slots){
			if(pageContextItems.length < 1){
				return [];
			}
			const mappedDataItemList = slots.getDataItemList();
			let categoriesCount = 0;
			_.each(mappedDataItemList, dataItem => {
				if(dataItem.getType() === 'attribute'){
					categoriesCount++;
				}
			});
			let resolvedPageContextItem = [];
			_.some(pageContextItems, item => {
				if(!item.isDataPointType()){
					_.each(item.getValues(), itemValue => {
						resolvedPageContextItem.push(itemValue.u.toString());
					});
				} else {
					if(item.getHierarchyCount() === categoriesCount){
						// intersection selection is not valid
						resolvedPageContextItem = [];
						return true;
					} else {
						_.each(item.getDataPoints(), dataPoint => {
							let dataPointItem = [];
							_.each(dataPoint, tuple => {
								dataPointItem.push(tuple.u);
							});
							resolvedPageContextItem.push(dataPointItem.join(','));
						});
					}
				}
			});
			return resolvedPageContextItem;
		}

		static getContextFromSelection(content, dashboard){
			const visApi = content.getFeature('WidgetAPI.deprecated').getVisApi();
			const visualization = content.getFeature('Visualization');
			const selectors = ContentUtil.getSelectors(content, dashboard);
			const pageContextItems = visApi.getPageContextAPI().getPageContextItems(selectors);
			const slots = visualization.getSlots();
			return ContentUtil._resolvePageContextItems(pageContextItems, slots);
		}

		static getSelectors(content, dashboard){
			const visualization = content.getFeature('Visualization');
			const eventGroups = dashboard.getFeature('EventGroups');
			const page = ContentUtilCommon.getPageContent(content);
			const selectors = {
				scope: page && page.getId(),
				eventGroupId : eventGroups.getGroupId(content.getId()),
				sourceId: visualization.getDataSource().getId(),
				origin: 'visualization',
				eventSourceId: content.getId()
			};
			return selectors;
		}

		static getColumnIdList(slotList = [], type) {
			let columnIdList = [];
			slotList.forEach(slot => {
				slot.getDataItemList().forEach(dataItem => {
					if(!type || dataItem.getType() === type) {
						columnIdList.push(dataItem.getColumnId());
					}
				});
			});
			return columnIdList;
		}
	}
	return ContentUtil;
});
